import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../api/client";

// Every page outside /battle and /login calls this on mount; couples
// with the one-active-game-per-user server constraint.
export function useActiveGameRedirect(): void {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const { active } = await api.getActiveGame();
        if (cancelled || !active) return;
        navigate(`/battle/${active.id}`, { replace: true });
      } catch {
        // 401 (logged out) or transient — let the page render
        // normally; it will surface its own error.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate]);
}
